import axios, { AxiosInstance } from 'axios'
import {
  CreateDomainInfoDto,
  CreateDomainValidEmailDto,
  DeleteDomainDto,
  DeleteDomainValidEmailDto,
  DomainUserDto,
  DomainUserParams,
  PatchDomainUserDto,
  SchoolInfoDto,
} from '@/module/domain/types'
import { PutDomainInfoDto } from './../module/domain/types'
import { Paths } from './paths'

const apiClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true
});

export async function fetchBizDomainList() {
  const result = await apiClient.get(Paths.GetBizDomain, {
  })

  return result.data.data
}

export async function createBizDomain(dto: CreateDomainInfoDto) {
  return await apiClient.post(Paths.UpdateBizDomain, dto, {
  })
}

export async function modifyBizDomain(dto: PutDomainInfoDto) {
  return await apiClient.put(Paths.UpdateBizDomain, dto, {
  })
}

export async function deleteBizDomain(dto: DeleteDomainDto) {
  return await apiClient.delete(Paths.UpdateBizDomain, {
    data: dto,
  })
}

export async function fetchEduDomainList() {
  const result = await apiClient.get(Paths.GetEduDomain, {
  })

  return result.data.data

  // const result = await fetch('/edu-list.json').then(async (response) => await response.json())
  // return result
}

export async function createEduDomain(dto: CreateDomainInfoDto) {
  return await apiClient.post(Paths.UpdateEduDomain, dto, {
  })
}

export async function modifyEduDomain(dto: PutDomainInfoDto) {
  return await apiClient.put(Paths.UpdateEduDomain, dto, {
  })
}

export async function deleteEduDomain(dto: DeleteDomainDto) {
  return await apiClient.delete(Paths.UpdateEduDomain, {
    data: dto,
  })
}

export async function fetchEduValidEmailList(domain: string) {
  const result = await apiClient.get(`${Paths.GetEduEmail}/${domain}`, {
  })

  return result.data.data

  // const response = await fetch('/edu-emails-list.json')
  // const jsonData = await response.json()
  // console.log(jsonData)

  // return jsonData
}

export async function createEduValidEmails(dto: CreateDomainValidEmailDto) {
  return await apiClient.post(`${Paths.UpdateEduEmail}/${dto.domain}`, dto.body, {
  })
}

export async function deleteEduValidEmails(dto: DeleteDomainValidEmailDto) {
  return await apiClient.delete(`${Paths.UpdateEduEmail}/${dto.domain}`, {
    data: dto.body,
  })
}

export async function fetchEduDomainUsers(
  domain: string,
  params: DomainUserParams,
): Promise<DomainUserDto[]> {
  const result = await apiClient.get(
    `/api/edu/domain/${domain}/users${params.level ? `?level=${params.level}` : ''}`,
    {
    },
  )

  return result.data.data
}

export async function patchEduDomainUserLevel(data: PatchDomainUserDto) {
  return await apiClient.patch(`/api/edu/domain/${data.domain}/users/level`, data.data, {
  })
}

export async function fetchEduSchoolList(keyword: string): Promise<SchoolInfoDto[]> {
  const result = await apiClient.get(Paths.GetEduSchool, {
    params: {
      keyword,
    },
  })

  return result.data.data
}

export async function signout() {
  return await apiClient.get(Paths.SignOut);
}